import { render, staticRenderFns } from "./polygonStyle.vue?vue&type=template&id=0d928c28&"
import script from "./polygonStyle.vue?vue&type=script&lang=ts&"
export * from "./polygonStyle.vue?vue&type=script&lang=ts&"
import style0 from "./polygonStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports